import * as Yup from "yup";

// validation rule while editing a client invoice
export const getClientInvoiceValidationSchema = () => {
  console.log(`inside getClientInvoiceValidationSchema`);
  const validationSchema = Yup.object().shape({
    // ROUTE DATA
    totalOrders: Yup.number().when("show_route", (show_route, schema) => {
      const variableType = typeof show_route;
      const isShowRoute =
        (variableType === "boolean" && show_route) ||
        (variableType === "object" && show_route[0]);
      if (isShowRoute) {
        console.log(`show_route is true`);
        return schema
          .min(0)
          .required("Total Orders is required")
          .test(
            "totalOrders",
            "The sum of orders delivered and orders undelivered must equal total orders!",
            (value, context) => {
              const { parent } = context;

              return (
                parent.ordersDelivered + parent.ordersUndelivered ===
                parent.totalOrders
              );
            }
          );
      }
      return schema.optional();
    }),
    ordersDelivered: Yup.number().when("show_route", (show_route, schema) => {
      const variableType = typeof show_route;
      const isShowRoute =
        (variableType === "boolean" && show_route) ||
        (variableType === "object" && show_route[0]);
      if (isShowRoute)
        return schema.min(0).required("Orders Delivered is required");
      return schema.optional();
    }),
    ordersUndelivered: Yup.number().when("show_route", (show_route, schema) => {
      const variableType = typeof show_route;
      const isShowRoute =
        (variableType === "boolean" && show_route) ||
        (variableType === "object" && show_route[0]);
      if (isShowRoute)
        return schema.min(0).required("Orders Undelivered is required");
      return schema.optional();
    }),
    ordersUndeliveredNoAttempt: Yup.number().when(
      "show_route",
      (show_route, schema) => {
        const variableType = typeof show_route;
        const isShowRoute =
          (variableType === "boolean" && show_route) ||
          (variableType === "object" && show_route[0]);
        if (isShowRoute)
          return schema
            .min(0)
            .required("Orders Undelivered No Attempt is required");
        return schema.optional();
      }
    ),

    // ONE-TIME ADJUSTMENT
    totalLateCancellation: Yup.number().optional(),
    onetimeAdjustmentValue: Yup.number().optional(),
    onetimeAdjustmentDescription: Yup.string().when(
      "onetimeAdjustmentValue",
      (onetimeAdjustmentValue, schema) => {
        // if (
        //   onetimeAdjustmentValue !== null ||
        //   onetimeAdjustmentValue[0] !== null
        // )
        //   return schema.required();
        return schema.optional();
      }
    ),

    // RATE CARD DATA
    baseRate: Yup.number().when("show_discount", (show_discount, schema) => {
      console.log(`Yup validations isShowDiscount = ${show_discount}`);
      const variableType = typeof show_discount;
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (isShowDiscount)
        return schema.min(0).required("Base rate is required");
      return schema.optional();
    }),
    variableRate: Yup.number().when(
      "show_discount",
      (show_discount, schema) => {
        const variableType = typeof show_discount;
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (isShowDiscount)
          return schema.min(0).required("Variable rate is required");
        return schema.optional();
      }
    ),
    variableRateType: Yup.string().when(
      "show_discount",
      (show_discount, schema) => {
        const variableType = typeof show_discount;
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (isShowDiscount)
          return schema.required("Variable rate type is required");
        return schema.optional();
      }
    ),
    routeMinimum: Yup.number().when(
      "show_discount",
      (show_discount, schema) => {
        const variableType = typeof show_discount;
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (isShowDiscount)
          return schema.min(0).required("Route minimum is required");
        return schema.optional();
      }
    ),
    lateCancellationCharge: Yup.number().when(
      "show_discount",
      (show_discount, schema) => {
        const variableType = typeof show_discount;
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (isShowDiscount)
          return schema.min(0).required("Late cancellation charge is required");
        return schema.optional();
      }
    ),
    // discount validations
    ...discountValidations,

    // fuel surcharge validations
    ...fuelSurchargeValidations,

    // peak surcharge validations
    ...peakSurchargeValidations,
  });

  return validationSchema;
};

const discountValidations = {
  discount_custom_value: Yup.number().optional(),
  discount_type: Yup.string().when(
    ["show_ratecard", "show_discount", "discount_custom_value"],
    ([show_ratecard, show_discount, discount_custom_value], schema) => {
      const variableType = typeof show_discount;
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);

      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);

      if (isShowRatecard && isShowDiscount && !discount_custom_value)
        return schema.required(
          "At least one of the discount types is required"
        );
      return schema.optional();
    }
  ),
  // VOLUME
  discount_volume_min_unit: Yup.number().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "volume" &&
        !discount_custom_value
      )
        return schema.required("Please fill this field");

      return schema.optional();
    }
  ),
  discount_volume_frequency: Yup.string().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);

      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "volume" &&
        !discount_custom_value
      )
        return schema.required("Please choose any one");

      return schema.optional();
    }
  ),
  discount_volume_unit_type: Yup.string().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "volume" &&
        !discount_custom_value
      )
        return schema.required(
          "At least one of the volume value types is required"
        );
      return schema.optional().nullable();
    }
  ),
  discount_volume_value_percentage: Yup.number()
    .max(100, "Percentage accpets a max value of 100!")
    .when(
      [
        "show_ratecard",
        "show_discount",
        "discount_type",
        "discount_volume_unit_type",
        "discount_custom_value",
      ],
      (
        [
          show_ratecard,
          show_discount,
          discount_type,
          discount_volume_unit_type,
          discount_custom_value,
        ],
        schema
      ) => {
        const variableType = typeof show_discount;
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        const isShowRatecard =
          (variableType === "boolean" && show_ratecard) ||
          (variableType === "object" && show_ratecard[0]);
        if (
          isShowRatecard &&
          isShowDiscount &&
          discount_type === "volume" &&
          discount_volume_unit_type === "percentage" &&
          !discount_custom_value
        )
          return schema.required("Please fill this field");
        return schema.optional();
      }
    ),
  discount_volume_value_dollar: Yup.number()
    .max(100, "Percentage accpets a max value of 100!")
    .when(
      [
        "show_ratecard",
        "show_discount",
        "discount_type",
        "discount_volume_unit_type",
        "discount_custom_value",
      ],
      (
        [
          show_ratecard,
          show_discount,
          discount_type,
          discount_volume_unit_type,
          discount_custom_value,
        ],
        schema
      ) => {
        const variableType = typeof show_discount;
        const isShowRatecard =
          (variableType === "boolean" && show_ratecard) ||
          (variableType === "object" && show_ratecard[0]);
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (
          isShowRatecard &&
          isShowDiscount &&
          discount_type === "volume" &&
          discount_volume_unit_type === "value" &&
          !discount_custom_value
        )
          return schema.required("Please fill this field");
        return schema.optional();
      }
    ),
  // RATE
  discount_rate_type: Yup.string().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "rate" &&
        !discount_custom_value
      )
        return schema.required("Please choose any one");

      return schema.optional();
    }
  ),
  discount_rate_min_unit: Yup.number().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "rate" &&
        !discount_custom_value
      )
        return schema.required("Please fill this field");

      return schema.optional();
    }
  ),
  discount_rate_frequency: Yup.string().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "rate" &&
        !discount_custom_value
      )
        return schema.required("Please choose any one");

      return schema.optional();
    }
  ),
  discount_rate_unit_type: Yup.string().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_custom_value",
    ],
    (
      [show_ratecard, show_discount, discount_type, discount_custom_value],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "rate" &&
        !discount_custom_value
      )
        return schema.required(
          "At least one of the rate value types is required"
        );
      return schema.optional().nullable();
    }
  ),
  discount_rate_value_percentage: Yup.number()
    .max(100, "Percentage accpets a max value of 100!")
    .when(
      [
        "show_ratecard",
        "show_discount",
        "discount_type",
        "discount_rate_unit_type",
        "discount_custom_value",
      ],
      (
        [
          show_ratecard,
          show_discount,
          discount_type,
          discount_rate_unit_type,
          discount_custom_value,
        ],
        schema
      ) => {
        const variableType = typeof show_discount;
        const isShowRatecard =
          (variableType === "boolean" && show_ratecard) ||
          (variableType === "object" && show_ratecard[0]);
        const isShowDiscount =
          (variableType === "boolean" && show_discount) ||
          (variableType === "object" && show_discount[0]);
        if (
          isShowRatecard &&
          isShowDiscount &&
          discount_type === "rate" &&
          discount_rate_unit_type === "percentage" &&
          !discount_custom_value
        )
          return schema.required("Please fill this field");
        return schema.optional();
      }
    ),
  discount_rate_value_dollar: Yup.number().when(
    [
      "show_ratecard",
      "show_discount",
      "discount_type",
      "discount_rate_unit_type",
      "discount_custom_value",
    ],
    (
      [
        show_ratecard,
        show_discount,
        discount_type,
        discount_rate_unit_type,
        discount_custom_value,
      ],
      schema
    ) => {
      const variableType = typeof show_discount;
      const isShowRatecard =
        (variableType === "boolean" && show_ratecard) ||
        (variableType === "object" && show_ratecard[0]);
      const isShowDiscount =
        (variableType === "boolean" && show_discount) ||
        (variableType === "object" && show_discount[0]);
      if (
        isShowRatecard &&
        isShowDiscount &&
        discount_type === "rate" &&
        discount_rate_unit_type === "value" &&
        !discount_custom_value
      )
        return schema.required("Please fill this field");
      return schema.optional();
    }
  ),
};

const fuelSurchargeValidations = {
  fuel_surcharge_custom_value: Yup.number().optional(),
  fuelType: Yup.string().when(
    ["show_fuel_surcharge", "fuel_surcharge_custom_value"],
    ([show_fuel_surcharge, fuel_surcharge_custom_value], schema) => {
      const variableType = typeof show_fuel_surcharge;
      const isShowFuelSurcharge =
        (variableType === "boolean" && show_fuel_surcharge) ||
        (variableType === "object" && show_fuel_surcharge[0]);
      if (isShowFuelSurcharge && !fuel_surcharge_custom_value)
        return schema.required("Please select the fuel type");
      return schema.optional();
    }
  ),
  regionName: Yup.string().when(
    ["show_fuel_surcharge", "fuel_surcharge_custom_value"],
    ([show_fuel_surcharge, fuel_surcharge_custom_value], schema) => {
      const variableType = typeof show_fuel_surcharge;
      const isShowFuelSurcharge =
        (variableType === "boolean" && show_fuel_surcharge) ||
        (variableType === "object" && show_fuel_surcharge[0]);
      if (isShowFuelSurcharge && !fuel_surcharge_custom_value)
        return schema.required("Please select a region");
      return schema.optional();
    }
  ),

  // fuel surcharge fields
  fuelSurchargeFields: Yup.array().when(
    ["show_fuel_surcharge", "fuel_surcharge_custom_value"],
    ([show_fuel_surcharge, fuel_surcharge_custom_value], schema) => {
      const variableType = typeof show_fuel_surcharge;
      const isShowFuelSurcharge =
        (variableType === "boolean" && show_fuel_surcharge) ||
        (variableType === "object" && show_fuel_surcharge[0]);
      if (isShowFuelSurcharge && !fuel_surcharge_custom_value) {
        return Yup.array()
          .min(1)
          .of(
            Yup.object().shape({
              fieldName: Yup.string().required("Required"),
              fieldOperator: Yup.string().required("Required"),
            })
          );
      }
      return Yup.array().optional();
    }
  ),

  fuelSurchargeLookup: Yup.array().when(
    ["show_fuel_surcharge","show_ratecard" ,"fuel_surcharge_custom_value"],
    ([show_fuel_surcharge, show_ratecard,fuel_surcharge_custom_value], schema) => {
      const variableType = typeof show_fuel_surcharge;
      const isShowFuelSurcharge =
        (variableType === "boolean" && show_fuel_surcharge) ||
        (variableType === "object" && show_fuel_surcharge[0]);
      if (isShowFuelSurcharge && !fuel_surcharge_custom_value) {
        return Yup.array().min(1).required("Please upload the file");
        // .of(
        //   Yup.object().shape({
        //     fscFile: Yup.string().required("Please upload the file"),
        //   })
        // );
      }
      return Yup.array().optional();
    }
  ),
};

const peakSurchargeValidations = {
  peak_surcharge_custom_value: Yup.number().nullable().typeError('Must be a number'),
  show_peak_surcharge: Yup.boolean().optional(),
  peakSurcharge: Yup.array().when(
    ['show_peak_surcharge', 'peak_surcharge_custom_value', 'show_ratecard'],
    {
      is: (show_peak_surcharge: any, peak_surcharge_custom_value: any, show_ratecard: any) => {
        // Only apply validations if show_ratecard is true
        if (!show_ratecard) return false;
        // Then check peak surcharge conditions
        return show_peak_surcharge === true && !peak_surcharge_custom_value;
      },
      then: (schema) => Yup.array().of(
        Yup.object().shape({
          peakSurchargeType: Yup.string()
            .oneOf(['percentage', 'value'])
            .optional(),
          peak_surcharge_value_percentage: Yup.number()
            .transform((value) => (isNaN(value) ? undefined : value))
            .optional(),
          peak_surcharge_value_dollar: Yup.number()
            .transform((value) => (isNaN(value) ? undefined : value))
            .optional()
        })
      ),
      otherwise: (schema) => schema.optional()
    }
  )
};
